import React from 'react';
import './style.scss';
import AuthComponent from '../AuthComponent';

import AuthorizedMain from './AuthorizedMain';
import NonAuthorizedMain from './NonAuthorizedMain';


export default AuthComponent( AuthorizedMain, NonAuthorizedMain );
